<!-- 

<app-sidenav></app-sidenav>

<router-outlet></router-outlet>

<app-footer></app-footer> -->

<div class="boxed_wrapper">
    <app-header (menuEvent)="handleMenuEvent($event)"></app-header>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
</div>

